<!-- 
 @fileoverview This is the Agent Home page templatee
 @author Harish Kumaran
 @created June, 2024
 -->
<div class="layout">
  <div class="heading">
    <h1>Humana</h1>
  </div>
  <div class="container col-md-9 mb-2">
    <div class="title">
      <h4>Welcome to Application Status tracker!</h4>
    </div>
    <div class="message">
      <p>
        Please enter Application Id(s) to view the status of Application(s)
      </p>
    </div>
    <form
      class="needs-validation"
      #userForm="ngForm"
      (ngSubmit)="onClick(userForm)"
    >
      <div class="tags-input-container mt-3 mb-3">
        <label for="applicationID"><h6>Application ID(s):</h6></label>
        <input
          #tagInput
          id="applicationID"
          type="text"
          [(ngModel)]="inputValue"
          name="applicationId"
          (keypress)="addTag($event)"
          placeholder="Please enter upto 5 Application IDs"
          class="w-full border p-2 rounded-lg"
        />
        <span class="col-md-12 note">Note: Please press Space/Enter after entering the application ID</span>
        <div class="tags">
          <span *ngFor="let tag of tags" class="tag">
            {{ tag }}
            <button class="remove-tag" (click)="removeTag(tag)">
              <mat-icon>cancel</mat-icon>
            </button>
          </span>
        </div>
        <span *ngIf="appIdError" class="col-md-12 appIdError">
          Please enter valid Application ID(s)
        </span>
      </div>
      <div class="row or">
        <div class="col-5"></div>
        <div class="col-2">
          <h6>(OR)</h6>
        </div>
        <div class="col-5"></div>
      </div>
      <div class="date mb-1">
        <div class="row">
          <h6>Select the Date Range</h6>
          <div class="col-6 mb-2">
            <label for="startdate"><h6>From:</h6></label>
            <input
              type="date"
              class="form-control"
              id="startdate"
              [(ngModel)]="startDate"
              (change)="onStartDateChange($event)"
              name="start"
            />
          </div>
          <div class="col-6 mb-2">
            <label for="enddate"><h6>To:</h6></label>
            <input
              type="date"
              class="form-control"
              id="enddate"
              [(ngModel)]="endDate"
              (change)="onEndDateChange($event)"
              name="end"
            />
          </div>
        </div>
      </div>
      <div class="button mb-1 mt-3">
        <button
          type="submit"
          class="btn btn-dark btn-sm"
          [disabled]="userForm.invalid"
        >
          Check Status
        </button>
      </div>
      <div *ngIf="maxDateError" class="error-message">
        Please enter Start Date and End Date within last 45 days
      </div>
      <div *ngIf="futureDateError" class="error-message">
        Please enter Start Date lesser than End Date
      </div>
      <div *ngIf="validationError" class="error-message">
        Please enter either Application ID(s) or valid Date Range
      </div>
    </form>
  </div>
</div>